<template>
  <v-layout v-if="!isShowingFirstScreen" :class="['button-group', `button-group${isSticky ? '-sticky' : ''}`]">
    <ButtonGroup
      v-if="!contentGenerated"
      :primaryBtnText="primaryBtnText"
      @primaryClicked="handlePrimaryClick"
      @secondaryClicked="handleSecondaryClick"
    ></ButtonGroup>
    <GeneratedContentInfoBar
      v-if="contentGenerated"
    ></GeneratedContentInfoBar>
  </v-layout>
</template>

<script>
import { ButtonGroup } from '../utils/buttons'
import { GeneratedContentInfoBar } from '../utils'
export default {
  name: 'SearchAIFooter',
  components: { ButtonGroup, GeneratedContentInfoBar },
  data () {
    return {
      isSticky: false
    }
  },
  computed: {
    contentGenerated: {
      get () { return this.$store.getters.getContentGenerated }
    },
    isShowingFirstScreen: {
      get () { return this.$store.getters.getResearchQuestionInputState.showSection }
    },
    primaryBtnText: {
      get () { return this.$store.getters.getFooterPrimaryBtnText }
    }
  },
  methods: {
    handlePrimaryClick () {
      this.isSticky = true
      if (this.primaryBtnText === 'Next') {
        this.$store.dispatch('handleNextKeywordsSection')
      } else if (this.primaryBtnText === 'Generate') {
        this.$store.dispatch('handleGenerateContent')
      }
    },
    handleSecondaryClick () {
      this.$store.dispatch('aiStateReverse')
    }
  }
}
</script>

<style scoped lang="scss">
.button-group {
  margin-top: 10px;
  padding: 10px 0;
  bottom: 0;
  background-color: $bg-primary;
  &-sticky {
    position: sticky;
    border-top-color: $blue-primary;
    border-top-style: solid;
    border-top-width: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/SearchAIFooter.vue